const fieldName = {
  COACH: 'coach',
  COACH_ID: 'coachId',
  NAME: 'formName',
  FIELDS: 'fields',
  HIDDEN_FIELDS: 'hiddenFields',
  END_SCREEN_CONTENT: 'endScreenContent',
};

const questionFieldName = {
  TYPE: 'type',
  ID: 'id',
  CUSTOM_CLASS: 'customClass',
  LABEL: 'label',
  PLACEHOLDER: 'placeholder',
  REQUIRED: 'required',
  FIELDS: 'fields',
  ALLOW_MULTIPLE: 'isMultiple',
  PROMPT_INPUT: 'promptInput',
  OPTIONS: 'options',
  VALUE: 'value',
  UNITS: 'units',
  UNIT_IDS: 'unitIds',
};

const heightUnitId = {
  FEET: 'ft',
  INCHES: 'in',
  CM: 'cm',
};

const weightUnitId = {
  POUNDS: 'lb',
  KILOGRAMS: 'kg',
};

const endScreenContentFieldName = {
  LINE_1: 'line1',
  LINE_2: 'line2',
};

const questionId = {
  FINANCIAL_COMMITMENT: 'financialCommitment',
};

export default fieldName;
export {
  questionFieldName,
  endScreenContentFieldName,
  heightUnitId,
  weightUnitId,
  questionId,
};
